import classnames from 'classnames'

import { H2, H4 } from 'components/heading/Heading'

import s from './StepHeader.module.scss'

const c = classnames.bind(s)

type Props = {
  title?: string
  subTitle?: string
  text?: string
}

export const StepHeader = ({ title, subTitle, text }: Props) => {
  if (!title && !subTitle && !text) {
    return null
  }

  return (
    <div
      className={c(s.stepHeader, {
        hasSubTitle: subTitle && subTitle.length > 0,
      })}
    >
      {title && (
        <H2 className={s.stepHeader__title} as="h1">
          {title}
        </H2>
      )}
      {subTitle && (
        <H4 as="h2" className={s.stepHeader__subTitle}>
          {subTitle}
        </H4>
      )}
      {text && <p className={s.stepHeader__text}>{text}</p>}
    </div>
  )
}
